module.exports = __webpack_public_path__ + "img/1f422.ad35599.svg";